'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { FaqPatientTabContent } from './faq-patient-tab-content.component';
import { FaqProfessionalTabContent } from './faq-professional-tab-content.component';

import { FaqTopic } from '@/app/(main)/(pages)/(institucional)/preciso-de-ajuda/_types/faq.type';
import { Tabs, TabsContent, TabsList, TabsProvider, TabsTrigger } from '@/components/ui/tabs';

interface FaqTabsProps {
  faqContent: FaqTopic[];
  isActiveStageOne: boolean;
}

export const FaqTabs = ({ faqContent, isActiveStageOne }: FaqTabsProps) => {
  return (
    <>
      <TabsProvider>
        <Tabs defaultValue="patient" activationMode="manual" className="w-full flex flex-col items-start">
          <TabsList className="flex flex-row items-center gap-4 mb-4">
            <TabsTrigger value="patient" data-testid={DataTestIdEnum.FAQ_PATIENT_TAB_TRIGGER}>
              Paciente
            </TabsTrigger>
            <TabsTrigger value="professional" data-testid={DataTestIdEnum.FAQ_PROFESSIONAL_TAB_TRIGGER}>
              Profissional da saúde
            </TabsTrigger>
          </TabsList>

          <TabsContent value="patient" className="flex flex-col gap-4 w-full">
            <FaqPatientTabContent faqContent={faqContent} isActiveStageOne={isActiveStageOne} />
          </TabsContent>

          <TabsContent value="professional" className="flex flex-col gap-4 w-full">
            <FaqProfessionalTabContent />
          </TabsContent>
        </Tabs>
      </TabsProvider>
    </>
  );
};
